import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-password-restored-modal',
  templateUrl: './password-restored-modal.component.html',
  styleUrls: ['./password-restored-modal.component.scss'],
})
export class PasswordRestoredModalComponent implements OnInit {
  successful: boolean = false;
  constructor(private modalRef: BsModalRef) {}

  ngOnInit(): void {}

  close() {
    this.modalRef.hide();
  }
}
